import React, { useEffect } from "react";
import gql from "graphql-tag";
import {
  httpClient
} from "settings/apolloClient.jsx";
import { useControllerToken } from "../contexts/ControllerTokenContext";

const CONTROLLER_TOKEN_QUERY = gql`
query {
  controllerToken
}
`;

const withControllerToken = (Component) => (props) => {
  const { updateControllerToken } = useControllerToken();

  const getControllerToken = () => {
    httpClient
      .query({ query: CONTROLLER_TOKEN_QUERY })
      .then(({ data }) => updateControllerToken(data.controllerToken))
      .catch(() => updateControllerToken(null));
  };

  useEffect(() => {
    getControllerToken();
  }, []);

  return <Component {...props} />;
};

export default withControllerToken;
